module.exports = __webpack_public_path__ + "img/lipic3.14e0ddd6.svg";